import { Component } from '@angular/core';

import assertNever from 'app/utils/assert-never';
import { Loggable } from 'app/utils/logging/loggable';
import { SocialEventType, UpdateType } from 'messages/websocket.messages';

import { ShareScreenService } from '../../services/share-screen/share-screen.service';
import { VideoRoomService } from '../../services/video-room.service';
import SocialStateMachine from '../../social-state-machine/social-state-machine';
import { PresenterVideoQuality, RESOLUTION_1080P, RESOLUTION_720P, RESOLUTION_STANDARD } from '../../types/media';

@Component({
  selector: 'app-debugger-screenshare',
  templateUrl: './debugger-screenshare.component.html',
  styleUrl: './debugger-screenshare.component.scss',
  standalone: false,
})
export class DebuggerScreenshareComponent extends Loggable {
  protected framerate = 0; //this.shareScreenSerce.frameRate;
  protected svc = this.videoRoomService.getSvcSettings();
  protected bitrate = this.svc?.shareBitrate;
  protected overrideQuality = null;
  protected readonly PresenterVideoQuality = PresenterVideoQuality;
  protected hasAudio = 0; //this.shareScreenSerce.hasAudio;
  protected socialEventType = SocialEventType;

  public constructor(
    public videoRoomService: VideoRoomService,
    private shareScreenSerce: ShareScreenService,
  ) {
    super();
    this.setDisplayName('DebuggerPeerConnectionComponent');
  }

  public onQualityOverride(value: PresenterVideoQuality) {
    this.logUserAction('QualityOverrideDropdown', 'click', { value });
    switch (value) {
      case PresenterVideoQuality.QUALITY_STANDARD:
        this.bitrate = RESOLUTION_STANDARD.bitrate;
        // this.shareScreenSerce.bitrate = RESOLUTION_STANDARD.bitrate;
        break;
      case PresenterVideoQuality.QUALITY_720P:
        this.bitrate = RESOLUTION_720P.bitrate;
        // this.shareScreenSerce.bitrate = RESOLUTION_720P.bitrate;
        break;
      case PresenterVideoQuality.QUALITY_1080P: {
        this.bitrate = RESOLUTION_1080P.bitrate;
        // this.shareScreenSerce.bitrate = RESOLUTION_1080P.bitrate;
        break;
      }
      default: {
        assertNever(value);
      }
    }
  }

  public ovverideFramerate() {
    // this.shareScreenSerce.frameRate = this.framerate;
  }

  public ovverideAudio() {
    // this.shareScreenSerce.hasAudio = this.hasAudio;
  }

  protected async cleanPresentationState(crossRoomPresentation = true, presentationType: string) {
    if (presentationType === 'PRESENTATION') {
      await SocialStateMachine.shared.requestEndEvent({
        prevEventType: SocialEventType.PRESENTATION,
        userId: '',
        updateType: crossRoomPresentation ? UpdateType.ALL : UpdateType.CURRENT,
      });
    } else {
      await SocialStateMachine.shared.requestRemoveActiveScreenshares({
        presentationType,
        updateType: crossRoomPresentation ? UpdateType.ALL : UpdateType.CURRENT,
      });
    }
  }
}
